// Solana's staged 400ms -> 200ms slot time reduction, one feature gate per
// successive epoch: https://solana.com/upgrades/reduced-slot-times
// Tentative — the network pauses the ramp if block skip rates climb.
const SLOT_TIME_SCHEDULE: ReadonlyArray<{ fromEpoch: number; slotTimeSeconds: number }> = [
    { fromEpoch: 0, slotTimeSeconds: 0.4 },
    { fromEpoch: 1020, slotTimeSeconds: 0.35 },
    { fromEpoch: 1024, slotTimeSeconds: 0.3 },
    { fromEpoch: 1037, slotTimeSeconds: 0.25 },
    { fromEpoch: 1057, slotTimeSeconds: 0.2 },
];

export const slotTimeSecondsFor = (epoch: number): number => {
    let slotTimeSeconds = SLOT_TIME_SCHEDULE[0].slotTimeSeconds;
    for (const stage of SLOT_TIME_SCHEDULE) {
        if (epoch < stage.fromEpoch) break;
        slotTimeSeconds = stage.slotTimeSeconds;
    }
    return slotTimeSeconds;
};

// Charges each epoch its own slot time: a two-epoch span can straddle three rates.
export const secondsBetweenSlots = (
    fromSlot: number,
    toSlot: number,
    slotsPerEpoch: number
): number => {
    let seconds = 0;
    let slot = fromSlot;
    while (slot < toSlot) {
        const epoch = Math.floor(slot / slotsPerEpoch);
        const chunkEnd = Math.min((epoch + 1) * slotsPerEpoch, toSlot);
        seconds += (chunkEnd - slot) * slotTimeSecondsFor(epoch);
        slot = chunkEnd;
    }
    return seconds;
};
